

export function parseQuerystring(url) {

    // so this is a neat trick whereby you can add the url to an a element and
    // it then exposes the different parts of the url with a convenient api.
    var parser = document.createElement('a');
    parser.href = url;

    // strip the ? from the querystring if it's there
    const querystring = parser.search.replace('?', '');

    // if we have an empty string then we just want to return an empty object.
    if ( querystring === '' ) {
        return {}
    }

    const params = {};
    const querystringComponents = querystring.split('&');

    querystringComponents.map(item => {

        const components = item.split('=');

        // want to do some sanity checking here
        if ( components.length !== 2 ) {
            // we've got a bad number of components so we will skip this parameter
            return  // noop
        }

        const key = decodeURIComponent(components[0]);
        const value = decodeURIComponent(components[1]);

        // add key to params if it doesn't already exist, and then append the value
        if ( !(key in params) ) {
            params[key] = [];
        }
        params[key].push(value)

    });

    return params

}

export function buildQuerystring(params) {

    let querystring = '';

    const paramKeys = Object.keys(params);

    // if there are no parameters then we can return early.
    if ( paramKeys.length === 0 ) {
        return querystring
    }

    const paramStrings = [];
    paramKeys.map(key => {

        // values are set in params as an array, so we need to iterate over them.
        const paramValues = params[key];
        paramValues.map(value => {
            const paramKey = encodeURIComponent(key);
            const paramValue = encodeURIComponent(value);

            const paramString = `${paramKey}=${paramValue}`;

            // we don't want duplicate parameters, so we don't append if duplciates occur.
            if ( !paramStrings.includes(paramString) ) {
                paramStrings.push(paramString)
            }
        });

    });

    let firstQueryParam = true
    paramStrings.map(item => {

        if ( firstQueryParam ) {
            querystring += '?';
            firstQueryParam = false;
        } else {
            querystring += '&'
        }

        querystring += item;

    });

    return querystring

}
